(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var parcelRequire = $parcel$global["parcelRequirefdb2"];
parcelRequire.register("2UsKn", function(module, exports) {

$parcel$export(module.exports, "openTeamModal", function () { return $21e71c47b11f66af$export$2441799e30416085; });

var $asWDE = parcelRequire("asWDE");
/*
|--------------------------------------------------------------------------
| A function that scrolls to a particular slide before opening the team modal
|--------------------------------------------------------------------------
*/ var $21e71c47b11f66af$export$2441799e30416085 = function(modalId, slideId) {
    var _splideInstance_Components_Elements;
    var targetModal = document.getElementById(modalId);
    if (!targetModal) return;
    var modalTrack = targetModal.querySelector(".splide__list");
    var splideInstance = targetModal.splideInstance;
    var slides = (_splideInstance_Components_Elements = splideInstance.Components.Elements) === null || _splideInstance_Components_Elements === void 0 ? void 0 : _splideInstance_Components_Elements.slides;
    if (!slides) return;
    // Find the assocaited slide using the data-slide-id attribute
    var targetSlideIndex = slides.findIndex(function(slide) {
        return slide.dataset.slideId == slideId;
    });
    if (targetSlideIndex !== -1) {
        // Disable transitions
        modalTrack.style.transition = "none !important";
        // Scroll to the specified slide
        splideInstance.Components.Controller.go(targetSlideIndex);
        // Re-enable transitions
        modalTrack.style.transition = "";
    }
    // Open the modal
    (0, $asWDE.openModal)(modalId);
};

});

})();
//# sourceMappingURL=team-modal-helpers.b7c60050.js.map
